// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />


import { CustomQuestionManager } from "../../common/CustomQuestionManager";
import { IntakeCancelDialog } from "../../common/IntakeCancelDialog";
import { ProgramServiceAccount } from "../../common/ProgramServiceAccount";
import { RebateReassignment } from "../../common/RebateReassignment";
import { RequiredFieldBinder } from "../../common/RequiredFieldBinder";
import { RetailerTypeAhead } from "../../common/RetailerTypeahead";


export class CustomerEdit {


    public static Init(): void {

        let fromCIS: boolean = $("#PremiseFromCIS").val() == "True";
        let url: string = `${window.location.origin}/api/requiredfields/customer`;
        var reqFldBinder: RequiredFieldBinder = new RequiredFieldBinder();
        reqFldBinder.SetProgramRequiredFieldsByPageApplyRules(url, "ApplicationInformation", CustomerEdit.OnRequiredFieldsDataBound, false, fromCIS);

        if ($("#application-form").length) {
            CustomerEdit.BindFieldMasking();
            CustomerEdit.BindFieldHandlers();
            CustomerEdit.ToggleTextMessageOptions();

            RebateReassignment.Init();
            ProgramServiceAccount.Init();
        }

        var retailerUrl: string = `${window.location.origin}/api/RetailerApi`;
        var retailerTypeAhead = new RetailerTypeAhead(retailerUrl);
        retailerTypeAhead.Setup();

    }

    private static OnRequiredFieldsDataBound(): void {

        //Set default state for House fields.
        CustomerEdit.ToggleGasElectricSlider();
        CustomerEdit.ShowHideBasementSquareFootage();
        CustomerEdit.ShowHideBuildingTypeOther();
        CustomerEdit.ShowHideHouseFuelTypeOther();
        CustomerEdit.ShowHideWaterHeaterFuelTypeOther();

        //retailer typeahead
        RetailerTypeAhead.ShowHideRetailerOtherFields();

        RebateReassignment.SetRebatePaymentSectionCustomer();
        ProgramServiceAccount.InitProgramServiceAccountFields();
        CustomQuestionManager.Init();

        //Must be called after fields are visible.
        CustomerEdit.BindEmailComparison();
    }


    private static BindFieldMasking(): void {
        (<any>$("#ApplicationInformation_ProjectZipCode")).mask("00000", { clearIfNotMatch: true });
        (<any>$("#ApplicationInformation_PayeeZipCode")).mask("00000", { clearIfNotMatch: true });
        (<any>$("#ApplicationInformation_RetailerZipCode")).mask("00000", { clearIfNotMatch: true });

        (<any>$("#ApplicationInformation_CustomerPhoneNumber")).mask("(000) 000-0000", { clearIfNotMatch: true });
        (<any>$("#ApplicationInformation_CustomerCellPhoneNumber")).mask("(000) 000-0000", { clearIfNotMatch: true });
        (<any>$("#ApplicationInformation_CustomerWorkPhoneNumber")).mask("(000) 000-0000", { clearIfNotMatch: true });
    }

    private static BindFieldHandlers(): void {

        CustomerEdit.BindContinueButtonHandler();
        IntakeCancelDialog.Init();

        //Needed to post back disabled select lists, otherwise field is empty
        $('#application-form').on('submit', function () {
            $('select').removeAttr('disabled');
        });

        $("#ApplicationInformation_CustomerCellPhoneNumber").on("blur", (e) => {
            CustomerEdit.ToggleTextMessageOptions();
        });

        $("#ApplicationInformation_FuelTypeInformation_CurrentHouseFuelTypeId").on("change", (e) => {
            this.ClearHeatingSystemTypes();
            this.ShowHideHouseFuelTypeOther();
            this.ToggleGasElectricSlider();
        });

        $('input[name="ApplicationInformation.HasBasement"]').on("change", (e) => {
            this.ShowHideBasementSquareFootage()
        });

        $('#ApplicationInformation.BuildingTypeId').on("change", (e) => {
            this.ShowHideBuildingTypeOther();
        });

        $('#ApplicationInformation_FuelTypeInformation_CurrentWaterHeaterFuelTypeId').on("change", (e) => {
            this.ShowHideWaterHeaterFuelTypeOther();
        });
    }

    private static BindContinueButtonHandler(): void {
        $("#continueButton").one('click', (evt) => {
            if ($("#application-form").valid()) {
                $(evt.target).slideUp();
                $("#application-form").trigger("submit");
            } else {
                this.BindContinueButtonHandler();
                var errorDiv = $('.field-validation-error:visible').first();
                var scrollPos = errorDiv.offset().top - 100;
                $('html,body').animate({ scrollTop: scrollPos }, 'slow');
            }
        });
    }

    //This needs to be called after Required Fields are bound so that the proper fields are visible.
    private static BindEmailComparison(): void {

        if ($("#ApplicationInformation_ConfirmEmailAddress").is(':visible')) {
            var inpt = $("#ApplicationInformation_ConfirmEmailAddress");
            inpt.rules("add", {
                minlength: 1,
                required: true,
                equalTo: '#ApplicationInformation_CustomerEmailAddress',
                messages: {
                    equalTo: jQuery.validator.format('The Confirmation Email Address does not match the Email Address')
                }
            });
        }
    }

    private static ToggleTextMessageOptions(): void {
        var x = $("#ApplicationInformation_CustomerCellPhoneNumber").val();
        if (x) {
            $('input[name="ApplicationInformation.AllowTextMessages"]').prop('disabled', false);
            $('input[name="ApplicationInformation.AllowTextMessages"]').closest('.form-check-label').removeClass('text-muted');
        } else {
            $('input[name="ApplicationInformation.AllowTextMessages"]').prop('checked', false);
            $('input[name="ApplicationInformation.AllowTextMessages"]').prop('disabled', true);
            $('input[name="ApplicationInformation.AllowTextMessages"]').closest('.form-check-label').addClass('text-muted');
        }
    }


    private static ShowHideBasementSquareFootage(): void {
        var v = $('input[name="House.HasBasement"]:checked').val();
        if (v == 'True') {
            this.EnableBasementSquareFootage();
        }
        else {
            this.DisableBasementSquareFootage();
        }
    }

    private static EnableBasementSquareFootage(): void {
        if (!$("#divHasBasement").is(":visible")) {
            $("#divHasBasement").removeClass("d-none").slideToggle("slow");
        }
    }

    private static DisableBasementSquareFootage(): void {
        if ($("#divHasBasement").is(":visible")) {
            $("#House_SquareFootageBasement").val("");
            $("#divHasBasement").slideToggle("slow");
        }
    }

    private static ShowHideBuildingTypeOther(): void {
        var btype = $('#ApplicationInformation_BuildingTypeId').val();
        if (btype == 'Other') {
            if (!$('#divBuildingTypeOther').is(":visible")) {
                $('#divBuildingTypeOther').removeClass("d-none").slideToggle("slow");
            }
        } else {
            if ($('#divBuildingTypeOther').is(":visible")) {
                $('#divBuildingTypeOther').slideToggle("slow");
                $('#ApplicationInformation_BuildingTypeOtherDescription').val('');
            }
        }
    }

    /////////////////////////////////////////////////////////////
    // Heating System Type Methods

    private static ToggleGasElectricSlider(): void {

        var ctrl = $("#ApplicationInformation_FuelTypeInformation_CurrentHouseFuelTypeId option:selected");
        if (ctrl == null) {
            return;
        }

        var currentHouseHeatingFuelType = ctrl.data('code-type');
        this.ShowHideHeatingSystemTypeByFuelType(currentHouseHeatingFuelType);

        return;
    }

    private static ShowHideHeatingSystemTypeByFuelType(currentHouseHeatingFuelType: string): void {
        var requireGasSystem1: boolean = currentHouseHeatingFuelType == 'FuelTypeGas';
        var requireGasSystem2: boolean = currentHouseHeatingFuelType == 'FuelTypeGas_Oil';
        var requireGasSystem3: boolean = currentHouseHeatingFuelType == 'FuelTypeGas_Propane';

        var requireGasSystem: boolean =
            requireGasSystem1 || requireGasSystem2 || requireGasSystem3;

        var requireOilSystem: boolean = currentHouseHeatingFuelType == 'FuelTypeOil';
        var requirePropaneSystem: boolean = currentHouseHeatingFuelType == 'FuelTypePropane';
        var requireElectricSystem: boolean = currentHouseHeatingFuelType == 'FuelTypeElectric';

        var gasCtrl = $("#ApplicationInformation_FuelTypeInformation_GasHeatingSystemTypeId");
        var electricCtrl = $("#ApplicationInformation_FuelTypeInformation_ElectricHeatingSystemTypeId");

        if (requireGasSystem) {
            electricCtrl.val("");
            this.ShowHeatingSystemType("#gas-heating-type-div", gasCtrl);
        } else if (requireElectricSystem) {
            gasCtrl.val("");
            this.ShowHeatingSystemType("#elec-heating-type-div", electricCtrl);
        } else if (requireOilSystem) {
            electricCtrl.val("");
            this.ShowHeatingSystemType("#oil-heating-type-div", gasCtrl);
        } else if (requirePropaneSystem) {
            electricCtrl.val("");
            this.ShowHeatingSystemType("#propane-heating-type-div", gasCtrl);
        } else {
            electricCtrl.val("");
            gasCtrl.val("");
        }
    }

    private static ClearHeatingSystemTypes(): void {

        //Stop animation and hide div
        $("#elec-heating-type-div").stop().hide();
        $("#gas-heating-type-div").stop().hide();
        $("#oil-heating-type-div").stop().hide();
        $("#propane-heating-type-div").stop().hide();

        $("#ApplicationInformation_FuelTypeInformation_GasHeatingSystemTypeId").val("");
        $("#ApplicationInformation_FuelTypeInformation_GasHeatingSystemTypeId").rules('remove', 'required');
        $("#ApplicationInformation_FuelTypeInformation_ElectricHeatingSystemTypeId").val("");
        $("#ApplicationInformation_FuelTypeInformation_ElectricHeatingSystemTypeId").rules('remove', 'required');
    }

    private static ShowHeatingSystemType(divName: string, fuelSystemCtrl: JQuery<HTMLElement>) {

        fuelSystemCtrl.rules('remove', 'required');
        fuelSystemCtrl.rules('add', {
            required: true,
            messages: {
                required: "Required"
            }
        });

        var len = $(divName).length;
        if (len > 0) {
            $(divName).stop().removeClass("d-none").slideDown("slow");
        }
    }

    private static ShowHideHouseFuelTypeOther(): void {
        var ftype = $("#ApplicationInformation_FuelTypeInformation_CurrentHouseFuelTypeId").val();
        if (ftype == 'Other') {
            if (!$('#divHouseHeatingOther').is(":visible")) {
                $('#divHouseHeatingOther').removeClass("d-none").slideToggle("slow");
            }
        } else {
            if ($('#divHouseHeatingOther').is(":visible")) {
                $('#divHouseHeatingOther').slideToggle("slow");
                $('#ApplicationInformation_FuelTypeInformation_CurrentHouseFuelTypeOtherDescription').val('');
            }
        }
    }

    private static ShowHideWaterHeaterFuelTypeOther(): void {
        var ftype = $("#ApplicationInformation_FuelTypeInformation_CurrentWaterHeaterFuelTypeId").val();
        if (ftype == 'Other') {
            if (!$('#divWaterHeatingOther').is(":visible")) {
                $('#divWaterHeatingOther').removeClass("d-none").slideToggle("slow");
            }
        } else {
            if ($('#divWaterHeatingOther').is(":visible")) {
                $('#divWaterHeatingOther').slideToggle("slow");
                $('#ApplicationInformation_FuelTypeInformation_CurrentWaterHeaterFuelTypeId').val('');
            }
        }
    }

    //
    //////////////////////////////////////////////////////////////

}

((window: any, document: any) => {
    $(() => {
        CustomerEdit.Init();
    });
})(window, document);